import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "../lib/api";
import { setCustomRoleLabels } from "../lib/i18n";

const Ctx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);

  useEffect(() => {
    // Saat kembali dari Google Auth (#session_id=), biarkan GoogleCallback yang menukar sesi.
    if (window.location.hash?.includes("session_id=")) { setUser(false); return; }
    if (!localStorage.getItem("access_token")) { setUser(false); return; }
    api.get("/auth/me").then((r) => setUser(r.data)).catch(() => { localStorage.removeItem("access_token"); setUser(false); });
    api.get("/auth/permissions").then((r) => setCustomRoleLabels(r.data.custom)).catch(() => {});
  }, []);

  const adopt = useCallback((data) => { localStorage.setItem("access_token", data.access_token); setUser(data.user); }, []);

  const login = useCallback(async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    localStorage.setItem("access_token", data.access_token);
    setUser(data.user);
    return data.user;
  }, []);

  const logout = useCallback(async () => {
    try { await api.post("/auth/logout"); } catch (e) { /* ignore */ }
    localStorage.removeItem("access_token");
    setUser(false);
  }, []);

  const can = useCallback((perm) => {
    const p = user?.permissions || [];
    return p.includes("*") || p.includes(perm);
  }, [user]);

  const refresh = useCallback(() => api.get("/auth/me").then((r) => setUser(r.data)).catch(() => {}), []);

  return <Ctx.Provider value={{ user, login, logout, can, adopt, refresh }}>{children}</Ctx.Provider>;
}

export const useAuth = () => useContext(Ctx);
